import { Component, Input } from '@angular/core';
import { PalleteColor } from 'nanaykuna-ui-kit/loader';

@Component({
  selector: 'unicon-section-header',
  templateUrl: './section-header.component.html',
})
export class SectionHeaderComponent {
  @Input() text!: string;
  @Input() type: string = 'h12';
  @Input() textColor: PalleteColor = 'neutrals-900';
}
